import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetInteriorReviewsRequest,
  GetInteriorReviewsResponse,
} from '../../model';

export class GetInteriorReviewsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetInteriorReviewsRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));

    // STORE-WEB-A4J: 인테리어 후기는 상품상세의 부가 정보(데이터 없으면 섹션
    // 자체를 숨김)라, 백엔드 지연/오류가 alert(Jira 티켓화)까지 발생시킬
    // 필요는 없다 — nonCritical로 log 수준만 남긴다.
    return await this.httpClient.request<GetInteriorReviewsResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/interior-reviews?${query}`,
      nonCritical: true,
    });
  }
}
